import React from "react"
import { Parallax } from "react-scroll-parallax"
import { ParallaxedText } from "./styles"

const Subheading = ({ children, color }) => {
  return (
    <Parallax x={["0", "-10%"]}>
      <ParallaxedText color={color}>{children}</ParallaxedText>
    </Parallax>
  )
}
export { Subheading }
